import {
  Button,
  Checkbox,
  createMuiTheme,
  FormControlLabel,
  MuiThemeProvider,
  TextField,
} from "@material-ui/core";
import React, { useEffect, useState } from "react";
import { shallowEqual, useSelector } from "react-redux";
import { useHistory, useLocation, useParams } from "react-router-dom";
import {
  Card,
  CardBody,
  CardHeader,
} from "../../../../_metronic/_partials/controls";
import {
  deleteDivisa,
  getDivisaById,
  postDivisa,
  updateDivisa,
} from "../../../../api/divisa";
import { postLog } from "../../../../api/log";
import { LOGS } from "../../../../utils/constants";
import { alertError, alertSuccess } from "../../../../utils/logger";
import ConfirmDialog from "../../../components/dialogs/ConfirmDialog";
import { useSkeleton } from "../../../hooks/useSkeleton";

// Create theme for delete button (red)
const theme = createMuiTheme({
  palette: {
    secondary: {
      main: "#F64E60",
    },
  },
});

function getEmptyDivisa() {
  return {
    name: "",
    divisa: "",
    default: false,
    activa: true,
  };
}

export default function EditDivisaPage() {
  const [divisa, setDivisa] = useState(getEmptyDivisa());
  const [openConfirmDialog, setOpenConfirmDialog] = useState(false);

  const divisaId = useParams().id;
  const history = useHistory();
  const location = useLocation();

  const loggedUser = useSelector(
    (store) => store.authentication?.user,
    shallowEqual
  );

  const {
    isLoading: isLoadingData,
    disableLoading: disableLoadingData,
    ContentSkeleton,
  } = useSkeleton();

  useEffect(() => {
    if (!divisaId) {
      disableLoadingData();
      return;
    }
    getDivisaById(divisaId)
      .then((res) => {
        if (res.status === 200) {
          setDivisa(res.data);
          disableLoadingData();
        }
      })
      .catch((error) => {
        alertError({
          error: error,
          customMessage: "Could not get currency.",
        });
        handleBack();
      });
  }, [divisaId, disableLoadingData, history]);

  const handleBack = () => {
    const prevTablePage = location?.state?.page;

    history.push(`/currencies${prevTablePage ? "?page=" + prevTablePage : ""}`);
  };

  function saveDivisa() {
    if (!divisaId) {
      postDivisa(divisa)
        .then((res) => {
          if (res.status === 201) {
            postLog(
              loggedUser,
              LOGS.FIELDS.DIVISAS,
              `${LOGS.ACTIONS.CREATE}-${divisa?.name}`
            );
            alertSuccess({
              title: "Saved!",
              customMessage: "Currency created successfully.",
            });
            handleBack();
          }
        })
        .catch((error) => {
          alertError({
            error: error,
            customMessage: "Could not save currency.",
          });
        });
    } else {
      updateDivisa(divisaId, divisa)
        .then((res) => {
          if (res.status === 200) {
            postLog(
              loggedUser,
              LOGS.FIELDS.COUNTRIES,
              `${LOGS.ACTIONS.UPDATE}-${divisa?.name}`
            );
            alertSuccess({
              title: "Saved!",
              customMessage: "Changes successfully saved.",
            });
            handleBack();
          }
        })
        .catch((error) => {
          alertError({
            error: error,
            customMessage: "Could not save changes.",
          });
        });
    }
  }

  const handleChange = (element) => (event) => {
    setDivisa({ ...divisa, [element]: event.target.value });
  };

  if (isLoadingData) return <ContentSkeleton />;
  else
    return (
      <>
        <Card>
          <CardHeader title="Edit currency"></CardHeader>
          <CardBody>
            <TextField
              id={`name`}
              label="Name"
              value={divisa.name}
              onChange={handleChange("name")}
              InputLabelProps={{
                shrink: true,
              }}
              margin="normal"
              variant="outlined"
              required
            />
            <TextField
              id={`divisa`}
              label="Sing"
              value={divisa.divisa}
              onChange={handleChange("divisa")}
              InputLabelProps={{
                shrink: true,
              }}
              margin="normal"
              variant="outlined"
              required
            />
            <FormControlLabel
              control={
                <Checkbox
                  checked={divisa.default}
                  onChange={() =>
                    setDivisa({
                      ...divisa,
                      default: !divisa.default,
                    })
                  }
                  name="checkDefault"
                />
              }
              label="Default"
            />
          </CardBody>
        </Card>
        <Button
          onClick={handleBack}
          variant="outlined"
          style={{ marginRight: "20px" }}
        >
          Back
        </Button>
        <Button
          onClick={() => saveDivisa()}
          variant="outlined"
          color="primary"
          style={divisaId && { marginRight: "20px" }}
        >
          Save currency
        </Button>
        {divisaId && (
          <>
            <MuiThemeProvider theme={theme}>
              <Button
                className="py-2"
                onClick={() => setOpenConfirmDialog(true)}
                variant="outlined"
                color="secondary"
              >
                Delete currency
              </Button>
            </MuiThemeProvider>
            <ConfirmDialog
              title={"Are you sure you want to delete this currency?"}
              open={openConfirmDialog}
              setOpen={setOpenConfirmDialog}
              onConfirm={() => {
                deleteDivisa(divisaId)
                  .then((res) => {
                    if (res.status === 204 || res.status === 200) {
                      postLog(
                        loggedUser,
                        LOGS.FIELDS.DIVISAS,
                        `${LOGS.ACTIONS.DELETE}-${divisa?.name}`
                      );
                      alertSuccess({
                        title: "Deleted!",
                        customMessage: "Currency deleted successfully.",
                      });
                      handleBack();
                    }
                  })
                  .catch((error) => {
                    alertError({
                      error: error,
                      customMessage: "Could not delete currency.",
                    });
                  });
              }}
            />
          </>
        )}
      </>
    );
}
